<template>
    <!--弹窗-->
    <el-dialog
        width="640px"
        title=""
        :visible.sync="visible"
        :before-close="handleClose"
        append-to-body
    >

        <el-form ref="formData" label-width="100px">


            <el-form-item label="分配人员" prop="userId">

                <el-radio :label="item.id" v-for="item in managerAnalysisList" :key="item.id" v-model="userId">
                    {{ item.full_name }}
                </el-radio>

            </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose" type="primary" size="mini">取 消</el-button>
            <el-button @click="submitForm" type="success" size="mini">确 定</el-button>
        </span>

    </el-dialog>
</template>
<script>

import * as api from '@/api/advAnalys/advAnalys'
import store from '@/store'
import {producer_allocate_production_link} from '@/api/advAnalys/advAnalys'

export default {
    data() {
        return {
            userId: null,
            disregarded_reason: null,
            visible: false,
            formData: {},
            managerAnalysisList: [],

        }
    },
    methods: {
        openModal(data) {
            const tempData = JSON.parse(JSON.stringify(data))
            this.formData = tempData
            this.getUserList()
            this.visible = true
        },
        getUserList() {
            api.manager_index_get_operator_list().then(res => {
                if (res.code === 0) {
                    this.managerAnalysisList = res.data || []

                    let id = this.formData.operation_id
                    this.$set(this, 'userId', Number(id))

                } else {
                    this.$message({type: 'error', message: res.message})
                }
            })
        },
        submitForm() {
            if (!this.userId) {
                this.$message({type: 'error', message: '请选择分配人员'})
                return
            }
            this.loading = true

            api.producer_allocate_production_link({
                id: this.formData.id,
                operation_id: this.userId
            }).then((res) => {
                if (res.success) {
                    this.$message.success(res.data)
                    this.handleClose(true)
                } else {
                    this.$message.error(res.message)
                }
            }).finally(() => {
                this.loading = false
            })

        },
        // 关闭弹窗
        handleClose(flag = false) {
            this.visible = false
            this.loading = false
            this.formData = {}
            this.$emit('close-callback', flag)
        }
    }
}
</script>
<style type="text/scss" lang="scss">
.wrapBox {
    width: 600px;
    margin-top: 10px;

    .bottomBox {
        margin-top: 17px;
        display: flex;
        justify-content: center;
    }
}

.download {
    display: flex;
    justify-content: center;
}

.top {
    margin: 0px auto 20px;
    width: 60%;
    display: flex;
    justify-content: space-between;
}
</style>

